<template>
  <div v-if="isCreatedInTargetPeriod && isInDisplayPeriod">
    <div v-if="feedbackNoticeMessage" class="reply-feedback--success feedback">
      <transition name="fade" @enter="enterSuccess">
        <FeedbackSuccess v-if="hasSuccess" :message="feedbackNoticeMessage" />
      </transition>
    </div>
    <div class="new-year__container">
      <div class="new-year__header">
        <div class="new-year__title"></div>
      </div>
      <div class="new-year__lottery-container">
        <div class="new-year__lottery-number-area">
          <div class="new-year__lottery-number-title"></div>
          <p class="new-year__lottery-number">
            {{ lotteryNumber }}
          </p>
        </div>
        <div class="new-year__token-area">
          <p class="new-year__token-explanation">
            下記のコードは当選時に使用します
          </p>
          <div class="new-year__token-display-area">
            <p class="new-year__token">
              {{ token }}
            </p>
            <button
              class="new-year__token-copy-button"
              @click="onClickCopyButton"
            >
              コピー
            </button>
          </div>
        </div>
      </div>
      <div class="new-year__announcement-container">
        <ButtonPrimary
          text="当選発表に関する詳細はこちら"
          @click-primary-button="onClickAnnouncementButton"
        />
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'

export default {
  components: {
    FeedbackSuccess,
    ButtonPrimary
  },
  props: {
    lotteryNumber: {
      type: String,
      require: true,
      default: ''
    },
    token: {
      type: String,
      require: true,
      default: ''
    },
    createdAt: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      feedbackNoticeMessage: '',
      hasSuccess: false
    }
  },
  computed: {
    isCreatedInTargetPeriod() {
      const formattedCreatedAt = dayjs(this.createdAt)
      return (
        formattedCreatedAt.isSameOrAfter('2024/12/26 15:00:00') &&
        formattedCreatedAt.isSameOrBefore('2025/01/10 23:59:59')
      )
    },
    isInDisplayPeriod() {
      return dayjs().isSameOrBefore('2025/01/31 23:59:59')
    }
  },
  methods: {
    enterSuccess() {
      setTimeout(() => {
        this.hasSuccess = false
      }, 3000)
    },
    onClickCopyButton() {
      const result = navigator.clipboard.writeText(this.token)
      if (result) {
        this.feedbackNoticeMessage = 'コピーしました'
        this.hasSuccess = true
        this.enterSuccess()
      }
      event.preventDefault()
    },
    onClickAnnouncementButton() {
      window.open('/announcements/527', '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
$yellowish-brown: #bf8400;
$red: #fc2b2b;

.new-year {
  &__container {
    margin-top: 16px;
    padding: 32px 16px;
    background-color: $white;
    background-position: right center;
    background-image: url('../../../../../images/new_year/bg-img.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
  }

  &__title {
    @include bg-settings(
      '../../../../../images/new_year/new-year-title.svg',
      transparent,
      100%,
      100%
    );
    height: 56px;
    width: 100%;
    margin-top: 8px;
  }

  &__lottery-container {
    background-color: $white;
    border-radius: 8px;
  }

  &__lottery-number-area {
    padding: 16px 24px;
  }

  &__lottery-number-title {
    @include bg-settings(
      '../../../../../images/new_year/lottery-number-title.svg',
      $white,
      100%,
      100%
    );
    height: 1.2rem;
  }

  &__lottery-number {
    font-style: normal;
    font-weight: 700;
    color: $red;
    text-align: center;
    font-size: 3.2rem;
    line-height: 100%;
    margin-top: 8px;
  }

  &__token-area {
    padding: 16px 24px;
    border-top: 1px dashed $gray-2;
  }

  &__token-explanation {
    @extend %caption;
  }

  &__token-display-area {
    display: flex;
    height: 44px;
    margin-top: 8px;
    padding: 0px 4px 0px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 60px;
    background: $gray-3;
  }

  &__token {
    @extend %caption;
    color: $black;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }

  &__token-copy-button {
    @extend %caption-bold;
    color: $black;
    height: 36px;
    padding: 4px 16px;
    border-radius: 50px;
    background: $white;
  }

  &__announcement-container {
    margin-top: 16px;

    button {
      background-color: $yellowish-brown;
    }
  }
}
</style>
